// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__BUjdm","Main":"Quote_Main__3wZQ1","Text":"Quote_Text__3WbG-","Source":"Quote_Source__3M3iQ"};